import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import PurchaseCancelRequestFields from './PurchaseCancelRequestFields'


export const PurchaseCancelRequestCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <PurchaseCancelRequestFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default PurchaseCancelRequestCreate
